<script>

	import './style.scss'

	export default {
		name: 'modal',
		props: ['show'],
		methods: {
			close: function () {
				this.$emit('close');
			}
		},
		mounted: function () {
			document.addEventListener('keydown', (e) => {
				if (this.show && e.keyCode == 27) {
					this.close();
				}
			});
		}
	}

</script>

<template>
	<transition name='modal'>
		<div class='modal-container' @click='close' v-show='show'>
			<div class='modal-content' @click.stop>
				<slot></slot>
			</div>
		</div>
	</transition>
</modal>


// WEBPACK FOOTER //
// src/components/Modal/Modal.vue